(() => {
  const technicalMapProperties = new Set([
    '_Renao Üretim',
    '_Enlem',
    '_Boylam',
    '_Harita Zoom',
    '_Harita Sahnesi',
    '_Kalp X',
    '_Kalp Y',
    '_Kalp Enlem',
    '_Kalp Boylam',
    '_Harita Şekli',
    '_Harita Stili',
    '_Başlık Fontu',
    '_İsim Fontu',
  ]);
  let activeRun = null;
  let checkoutBypass = false;

  const cartUrl = () => window.routes?.cart_url || '/cart';
  const changeUrl = () => window.routes?.cart_change_url || '/cart/change.js';
  const hasEmbeddedRecipe = (properties) => (
    /[#?&]r=v1\.[A-Za-z0-9_-]+/.test(String(properties?.['Tasarım Dosyası'] || ''))
    || /[#?&]r=v1\.[A-Za-z0-9_-]+/.test(String(properties?.['Tasarım Önizleme'] || ''))
  );
  const needsSanitizing = (item) => (
    hasEmbeddedRecipe(item?.properties)
    && Object.keys(item?.properties || {}).some((name) => technicalMapProperties.has(name))
  );

  const run = () => {
    if (activeRun) return activeRun;
    activeRun = (async () => {
      const response = await fetch(`${cartUrl()}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return false;
      const cart = await response.json();
      let changed = false;

      // Work backwards so Shopify line numbers stay stable if two identical
      // personalized items merge after their private duplicate fields vanish.
      for (let index = cart.items.length - 1; index >= 0; index -= 1) {
        const item = cart.items[index];
        if (!needsSanitizing(item)) continue;
        const properties = Object.fromEntries(
          Object.entries(item.properties || {}).filter(([name]) => !technicalMapProperties.has(name))
        );
        const update = await fetch(changeUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: index + 1,
            quantity: item.quantity,
            properties,
          }),
        });
        if (!update.ok) throw new Error('Could not clear the map cart properties.');
        changed = true;
      }
      return changed;
    })().catch((error) => {
      console.warn('Renao map cart property sanitizer failed.', error);
      return false;
    }).finally(() => {
      activeRun = null;
    });
    return activeRun;
  };

  const ready = run();
  window.RenaoCartPropertySanitizer = { run, ready };

  // A customer may complete an old cart after the storefront fix. Hold the
  // checkout click until that cart is migrated, then continue normally.
  document.addEventListener('click', async (event) => {
    if (checkoutBypass) return;
    const checkout = event.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    await run();
    try {
      if (!window.RenaoGiftWrap) throw new Error('Gift wrapping validation could not load. Refresh the page.');
      await window.RenaoGiftWrap.sync();
    } catch (error) {
      let message = document.getElementById('renao-checkout-error');
      if (!message) {
        message = document.createElement('p'); message.id = 'renao-checkout-error'; message.setAttribute('role', 'alert');
        checkout.insertAdjacentElement('beforebegin', message);
      }
      message.textContent = 'Gift wrapping could not be verified. Checkout was not opened; please try again.';
      return;
    }
    document.getElementById('renao-checkout-error')?.remove();
    checkoutBypass = true;
    checkout.click();
    window.setTimeout(() => { checkoutBypass = false; }, 0);
  }, true);

  // Also sanitize immediately after any newly added item, covering quick-add,
  // cart drawer and stale cached product pages with the same safe migration.
  const originalFetch = window.fetch;
  window.fetch = function renaoSanitizedFetch(...args) {
    const request = args[0];
    const url = typeof request === 'string' ? request : request?.url;
    return originalFetch.apply(this, args).then((response) => {
      if (url && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
        window.setTimeout(() => run(), 0);
      }
      return response;
    });
  };
})();
